import './Template';
import './slider';
import './fancybox';

import '../scss/proarte.scss';
